import { render, staticRenderFns } from "./plain-editor.vue?vue&type=template&id=31c192ad&scoped=true"
import script from "./plain-editor.vue?vue&type=script&lang=js"
export * from "./plain-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c192ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c192ad')) {
      api.createRecord('31c192ad', component.options)
    } else {
      api.reload('31c192ad', component.options)
    }
    module.hot.accept("./plain-editor.vue?vue&type=template&id=31c192ad&scoped=true", function () {
      api.rerender('31c192ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-button/plain-editor.vue"
export default component.exports